import React, { FC, useState, useEffect } from 'react'
import { ChevronDownIcon } from '@heroicons/react/outline'
import { ModuleType, LessonType } from '../../../types'
import { FlexGroup } from '../../Grid'
import { formatVideoLength } from '../../utils/formatVideoLength'
import { getModuleVideoLength } from '../../CourseLibraryView'
import { StyledLessonMapGroup, LessonMapItem } from '.'

type Props = {
  module: ModuleType;
  currentLesson: LessonType;
  courseSlug: string;
  setLessonComplete(lesson: LessonType): void;
}

const LessonMapGroup: FC<Props> = ({
  module, currentLesson, courseSlug, setLessonComplete
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const [completedModuleLessons, setCompletedModuleLessons] = useState(0)

  const getModuleCompletedLessons = () => {
    const completedLessons = module.lessons?.filter((lesson) => lesson.isCompleted)

    setCompletedModuleLessons(completedLessons?.length || 0)
  }

  const lessonIsInModule = () => {
    if (!module.lessons) {
      return false
    }

    const lesson = module.lessons.find((lesson) => lesson._id === currentLesson._id)

    return !!lesson
  }

  useEffect(() => {
    getModuleCompletedLessons()
  }, [JSON.stringify(module)])

  return (
    <StyledLessonMapGroup onToggle={() => setIsOpen(!isOpen)} open={lessonIsInModule()}>
      <summary>
        <div className="module-details">
          <span className="module-title">{module.title}</span>
          <span className="module-length">
            {module.label || 'Module'} ∙ {formatVideoLength(getModuleVideoLength(module))}
          </span>
        </div>
        <FlexGroup>
          <span className="module-completed">
            {completedModuleLessons} / {module.lessons?.length || 0}
          </span>
          <ChevronDownIcon className="module-chevron-icon" />
        </FlexGroup>
      </summary>
      <ol className="lesson-list">
        {module.lessons &&
          module.lessons.map((lesson, index) => {
            return (
              <li key={index}>
                <LessonMapItem
                  lesson={lesson}
                  courseSlug={courseSlug}
                  setLessonComplete={setLessonComplete}
                />
              </li>
            )
          })}
      </ol>
    </StyledLessonMapGroup>
  )
}

export default LessonMapGroup
